/* eslint-disable max-len */
import type { IconPrimitiveProps } from 'types';

const IconCourier = (props: IconPrimitiveProps) => {
  const {
    size = 24,
    ...rest
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      strokeWidth={1.5}
      {...rest}
    >
      <circle cx={10.001} cy={5.778} r={3.7} stroke="currentColor" strokeLinecap="round" strokeWidth={1.468} />
      <path stroke="currentColor" strokeLinecap="round" strokeWidth={1.5} d="M6.75 4.852h9.5M5 22v-6.914C5.015 14.057 5.652 12 8.077 12H12c1.259 0 3 .773 3 3.086V16.5" />
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m10 14.5 2.563 4.643h4.802c.545.012 1.635.318 1.635 1.442 0 1.125-1.09 1.406-1.635 1.406 0 0-4.862-.005-5.244 0-.383.006-.933-.088-1.533-1.036C10.262 20.44 9.113 18.888 8.5 18" />
    </svg>
  );
};
export default IconCourier;
